export const portfolioData = [
  {
    id: 1,
    img: "codingLiterature",
    title: "코딩문학제",
    desc: "판매를 넘어, 문화를 만들어갑니다. 20만 이상의 페이지뷰를 기록했습니다. ",
    url: "https://www.codingmoonhak.com/",
  },
  {
    id: 2,
    img: "spartaCodingClub",
    title: "코딩교육 1위, 스파르타코딩클럽",
    desc: "누적 수강생 약 50만 명. 브랜드 대상 2회 수상. 고객이 사랑하는 브랜드를 만들었습니다.  ",
    url: "https://spartacodingclub.kr/",
  },
  {
    id: 3,
    img: "variousProducts",
    title: "10개 이상의 프로덕트 시장 안착",
    desc: "월 10억원 규모의 마케팅 예산을 집행하며 꾸준히 흑자를 내고 있습니다.",
    url: "",
  },
];
